module.exports = __webpack_public_path__ + "img/010.a6d610e4.png";